module.exports = __webpack_public_path__ + "img/3f_r_excel@2x.e2513317.jpg";